import { Circle } from 'lucide-react'

export function OnlineStatusDot({
  supportsOnlineStatus,
  onlineStatus,
}: {
  supportsOnlineStatus: boolean
  onlineStatus: string
}) {
  if (!supportsOnlineStatus) return

  const isOnline = onlineStatus === 'Online'

  return (
    <div className="flex items-center gap-1 text-xs">
      <Circle className={`h-3 w-3 fill-current ${isOnline ? 'text-green-500' : 'text-red-500'}`} />
    </div>
  )
}
